'use client';

import { useChat } from '@/lib/chat-context';
import { useAuth } from '@/lib/auth-context';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function GlobalChatButton() {
    const { isAuthenticated } = useAuth();
    const { toggleChat, totalUnread, isChatOpen } = useChat();

    // Only show for authenticated users
    if (!isAuthenticated) return null;

    return (
        <div className="fixed bottom-6 right-6 z-50">
            <Button
                onClick={toggleChat}
                size="lg"
                className={cn(
                    'rounded-full w-14 h-14 shadow-lg hover:shadow-xl transition-all',
                    totalUnread > 0 && !isChatOpen && 'animate-pulse'
                )}
            >
                <MessageCircle className="w-6 h-6" />
                {totalUnread > 0 && !isChatOpen && (
                    <Badge className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-500 min-w-[24px] h-6 flex items-center justify-center px-1.5">
                        {totalUnread > 99 ? '99+' : totalUnread}
                    </Badge>
                )}
            </Button>
        </div>
    );
}
